import React from 'react';
import './portfolio.css';
import webApps from './web-project';
import androidApps from './andriod-project';

function Portfolio() {
  return (
    <div className='portfolio-container'>
      <div className='portfolio-jumbotron jumbotron jumbotron-fluid'></div>

      <div className='card-container container'>
        <div id='myCarousel' className='carousel slide' data-interval='false' data-ride='carousel'>
          <div
            className='carousel-inner' //data-aos="flip-left"
          >
            {/* carousel-item 1 */}
            <div className='carousel-item active'>
              <h2 className='portfolio-title text-center'>Web Application</h2>
              <p className='heading text-center'>Showing all projects. Scroll down to view more.</p>
              <div className='grid no-gutter'>
                {webApps.map((item) => (
                  <div key={item.id}>
                    {/*up className="col-md-6 col-lg-4" */}
                    <div
                      className='project'
                      style={{
                        backgroundImage: `url(${item.url})`,
                      }}
                    >
                      <h1 className='project-title'>{item.title}</h1>
                      <code className='description'>{item.description}</code>
                      {/* <div className="trigger"></div> */}
                      <div className='overlay'>
                        <div className='container frameworks'>
                          {item.tags.map((tag, idx) => (
                            <code className='api' key={idx}>
                              {tag}
                            </code>
                          ))}
                        </div>
                        <div className='btn-groups'>
                          <button className='project-btn btn1'>
                            <a href={item.liveDemo} target='_blank' rel='noreferrer'>
                              Demo
                            </a>
                          </button>

                          <button
                            type='button'
                            className='project-btn btn2'
                            data-toggle='tooltip'
                            data-placement='right'
                            title='View on Github'
                          >
                            <a href={item.github} target='_blank' rel='noreferrer'>
                              <i className='fab fa-github'></i>
                            </a>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/*end of carousel-item 1 */}

            {/* carousel-item 3 */}

            <div className='carousel-item container'>
              <h2 className='portfolio-title text-center'>Android Application</h2>
              <p className='heading text-center'>Showing all projects. Scroll down to view more.</p>
              <div className='grid no-gutter'>
                {androidApps.map((item) => (
                  <div key={item.id} className='col-md-6 col-lg-4'>
                    <div
                      className='project'
                      style={{
                        backgroundImage: `url(${item.url})`,
                      }}
                    >
                      <h1 className='project-title'>{item.title}</h1>
                      <code className='description'>{item.description}</code>
                      {/* <div className="trigger"></div> */}
                      <div className='overlay'>
                        <div className='container frameworks'>
                          {item.tags.map((tag, idx) => (
                            <code className='api' key={idx}>
                              {tag}
                            </code>
                          ))}
                        </div>
                        <div className='btn-groups'>
                          <button className='project-btn btn1'>
                            <a href={item.liveDemo} target='_blank' rel='noreferrer'>
                              Demo
                            </a>
                          </button>

                          <button
                            type='button'
                            className='project-btn btn2'
                            data-toggle='tooltip'
                            data-placement='right'
                            title='View on Github'
                          >
                            <a href={item.github} target='_blank' rel='noreferrer'>
                              <i className='fab fa-github'></i>
                            </a>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* end of carousel-item 3 */}
          </div>
        </div>
      </div>

      <a className='carousel-control-prev' href='#myCarousel' role='button' data-slide='prev'>
        <span className='icon'>
          <span className='carousel-control-prev-icon' aria-hidden='true'></span>
        </span>
        <span className='sr-only'>Previous</span>
      </a>

      <a className='carousel-control-next' href='#myCarousel' role='button' data-slide='next'>
        <span className='icon'>
          <span className='carousel-control-next-icon' aria-hidden='true'></span>
          <span className='sr-only'>Next</span>
        </span>
      </a>

      <div className='move-up'>
        {/* this will give you the foating button to move up page to the top, fa 2x is a second class to increase the size of the button */}
        <span
          onClick={() => {
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
          }}
        >
          <i className='fas fa-arrow-circle-up fa-2x'></i>
        </span>
      </div>
    </div>
  );
}

export default Portfolio;
